// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"a2126be0","238":"e4a9000b","239":"532cc20a","396":"eeac5654","453":"598e7740","455":"925a967f","857":"eab5dd91","946":"66f7f6bf"}[chunkId] + ".chunk.js";
};